// Обёртка над Яндекс.Метрикой (счётчик ecommerce/целей).
// Старый счётчик 31671701 не трогаем — он работает как есть.
// Новый счётчик 110407517 используем для целей (reachGoal) и ecommerce (dataLayer).

export const METRIKA_ID = 110407517;
export const CURRENCY = 'RUB';

function hasYm() {
    return typeof window !== 'undefined' && typeof window.ym === 'function';
}

function getDataLayer() {
    if (typeof window === 'undefined') return null;
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
}

/**
 * Отправить цель в Метрику.
 * @param {string} name - идентификатор цели
 * @param {object} [params] - доп. параметры визита
 */
export function reachGoal(name, params) {
    if (!name || !hasYm()) return;
    try {
        window.ym(METRIKA_ID, 'reachGoal', name, params || undefined);
    } catch (error) {
        console.error('[analytics] reachGoal failed:', error);
    }
}

/**
 * Отправить произвольное ecommerce-событие через dataLayer.
 * @param {'detail'|'add'|'remove'|'purchase'} action
 * @param {object} payload - тело ecommerce для указанного действия
 */
export function pushEcommerce(action, payload) {
    const dl = getDataLayer();
    if (!dl || !action || !payload) return;
    try {
        dl.push({
            ecommerce: {
                currencyCode: CURRENCY,
                [action]: payload,
            },
        });
    } catch (error) {
        console.error('[analytics] pushEcommerce failed:', error);
    }
}

/**
 * Нормализовать товар к формату ecommerce Метрики.
 */
export function toEcommerceProduct(product = {}) {
    const result = {};
    if (product.id !== undefined && product.id !== null) result.id = String(product.id);
    if (product.name) result.name = String(product.name);
    if (product.category) result.category = String(product.category);
    if (product.variant) result.variant = String(product.variant);
    if (product.price !== undefined && product.price !== null) result.price = Number(product.price);
    if (product.quantity !== undefined && product.quantity !== null) result.quantity = Number(product.quantity);
    return result;
}

/**
 * Просмотр карточки товара/тарифа.
 * @param {object|object[]} products
 */
export function ecommerceDetail(products) {
    const list = Array.isArray(products) ? products : [products];
    pushEcommerce('detail', { products: list.map(toEcommerceProduct) });
}

/**
 * Добавление товара (например, переход к оплате).
 * @param {object|object[]} products
 */
export function ecommerceAdd(products) {
    const list = Array.isArray(products) ? products : [products];
    pushEcommerce('add', { products: list.map(toEcommerceProduct) });
}

/**
 * Успешная покупка.
 * @param {object|object[]} products
 * @param {object} [action] - { id: orderId, revenue }
 */
export function ecommercePurchase(products, action = {}) {
    const list = Array.isArray(products) ? products : [products];
    const actionField = {};
    if (action.id !== undefined && action.id !== null) actionField.id = String(action.id);
    if (action.revenue !== undefined && action.revenue !== null) actionField.revenue = Number(action.revenue);
    pushEcommerce('purchase', {
        actionField,
        products: list.map(toEcommerceProduct),
    });
}

export default {
    reachGoal,
    pushEcommerce,
    ecommerceDetail,
    ecommerceAdd,
    ecommercePurchase,
    toEcommerceProduct,
    METRIKA_ID,
    CURRENCY,
};
